import * as React from 'react';
import {
  IconInfrastructureChildPlayground16,
  IconInfrastructureCommercialObject16,
  IconInfrastructurePet16,
  IconInfrastructureFastService16,
  IconInfrastructureFitness16,
  IconInfrastructureKid16,
  IconInfrastructureOffice16,
  IconInfrastructureHospital16,
  IconInfrastructurePool16,
  IconInfrastructureRestaurant16,
  IconInfrastructureSchool16,
  IconInfrastructureSpa16,
  IconInfrastructureSportsground16,
  IconInfrastructureSupermarket16,
  IconInfrastructureResting16,
} from '@cian/ui-kit-design-tokens/icons';

import { TInfrastructureType } from '../../../../../../types/newbuildingsCompare';

const INFRASTRUCTURE_ICONS_MAP: Record<TInfrastructureType, React.ReactNode> = {
  school: <IconInfrastructureSchool16 />,
  kindergarten: <IconInfrastructureKid16 />,
  polyclinic: <IconInfrastructureHospital16 />,
  children: <IconInfrastructureChildPlayground16 />,
  sport: <IconInfrastructureSportsground16 />,
  recreation: <IconInfrastructureResting16 />,
  dogs: <IconInfrastructurePet16 />,
  supermarket: <IconInfrastructureSupermarket16 />,
  restaurant: <IconInfrastructureRestaurant16 />,
  fitness: <IconInfrastructureFitness16 />,
  spa: <IconInfrastructureSpa16 />,
  pool: <IconInfrastructurePool16 />,
  domestic: <IconInfrastructureFastService16 />,
  commerce: <IconInfrastructureCommercialObject16 />,
  offices: <IconInfrastructureOffice16 />,
};

export function infrastructureIconMapper(iconType: TInfrastructureType): React.ReactNode {
  return INFRASTRUCTURE_ICONS_MAP[iconType];
}
